import { render, staticRenderFns } from "./StoreUser.vue?vue&type=template&id=4f2d4060&scoped=true"
import script from "./StoreUser.vue?vue&type=script&lang=js"
export * from "./StoreUser.vue?vue&type=script&lang=js"
import style0 from "./StoreUser.vue?vue&type=style&index=0&id=4f2d4060&lang=scss&scoped=true"
import style1 from "./StoreUser.vue?vue&type=style&index=1&id=4f2d4060&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d4060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2d4060')) {
      api.createRecord('4f2d4060', component.options)
    } else {
      api.reload('4f2d4060', component.options)
    }
    module.hot.accept("./StoreUser.vue?vue&type=template&id=4f2d4060&scoped=true", function () {
      api.rerender('4f2d4060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/clinic/StoreUser.vue"
export default component.exports